import { asPageWrapper } from '../Wrapper/composition';
import { Menu, MenuItem } from './Menu';
import {
  ContentNavigationProvider,
  type ContentNavigationRootProps,
} from './Root';

export * from './Menu';
export * from './Section';

export type PageContentNavigationProps = Omit<
  ContentNavigationRootProps,
  'children'
>;

const ContentNavigationSlot = asPageWrapper(
  (_props: PageContentNavigationProps): null => null,
  ContentNavigationProvider,
);

export const ContentNavigation = Object.assign(ContentNavigationSlot, {
  Menu: Object.assign(Menu, { Item: MenuItem }),
});
